module.exports = "/layout/app/images/logo-white.c41758ef.svg";